// Home Page Product Slider
if($('.product-slider').length > 0){
  $('.product-carousel').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay:true,
    arrows:true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll:3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
     
    ]
  });
}

// Home Page slideshow slider
if($('.slideshow-banner').length > 0){
  $('.slideshow-cstm').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    speed: 500,
    vertical: true,
    verticalSwiping: true,
    arrows:false,
    dots: true,
    responsive: [
       {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
         verticalSwiping: false,
        }
      }
    ]
  });
}

  // ----------------- popup video section --------------     
  $('.product-grids-items .main-product-card.video_popup_wrapper' ).on( "click", function() {
        var id_attr = $(this).attr('data-id');
        var images1 = $('#img-'+id_attr).html();
        $('#show_img2').html(images1);
     $("body").addClass('active');
      $(".custom-model-main").addClass('model-open');
    $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("play");
    });
    $(".close-btn.data.close-btn").click(function(){
    $(".custom-model-main").removeClass('model-open');
      $("body").removeClass('active');
      $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("pause");
      $(".custom_inner_wrapper .popup_video_inner video").get(0).currentTime = 0;
});

  // -----------custom faq's ------------

  $(".accordion_tab .blinking-icons-wrapper .heading-accordion").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accordion_tab .blinking-icons-wrapper .content-accordion").slideUp(500);
    } else {
      $(".accordion_tab .blinking-icons-wrapper .heading-accordion").removeClass("active");
      $(this).addClass("active");
      $(".accordion_tab .blinking-icons-wrapper .main-accordion .content-accordion").slideUp(500);
      $(this).siblings(".accordion_tab .blinking-icons-wrapper .content-accordion").slideDown(500);
    }
  });

// image-with-slider
if($('.image-with-slider').length > 0){
  $('.image-slides-wrapper').slick({
    infinite: true,
    slidesToScroll: 1,
    autoplay:true,
    speed: 200,
    arrows:false,
    vertical: true,
    verticalSwiping: true,
    responsive: [
       {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
           verticalSwiping: false
        }
      }
    ]
  });
}

$(document).ready(function(){
  
// Collection-list
  if($('.collection-list').hasClass('grid--2-col-desktop')){
    $('.slide_1, .slide_2, .slide_3, .slide_4').wrapAll("<div class='collection-list-left'></div>"); 
  }  

// bundle page
  
  $('.details-accoridon').click(function(){
    $(this).toggleClass('detail-icon');
    $('.details-wrap').toggleClass('show-details');
    if($('.details-wrap').hasClass('show-details')){
       $('span.detail-text').text('Less details');
    }
    else{
       $('span.detail-text').text('More details');
    }
  });
  
  $(window).scroll(function(){
    if ($(this).scrollTop() > 20) {
       $('.content-card').addClass('scroll-content');
      $('.product-cards-grid').addClass('scroll-content');
    } else {
       $('.content-card').removeClass('scroll-content');
      $('.product-cards-grid').removeClass('scroll-content');
    }
});

// Private Label page
  if($('.made-with-slider-section').length > 0){
    $('.made-with-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay:true,
    speed: 700,
    arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:2,
          slidesToScroll:2
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
     
    ]
  });
}

// Our Mission Page

  if($('.multigrid-list').hasClass('grid--3-col-desktop')){
    $('.multigrid-2, .multigrid-3, .multigrid-4, .multigrid-5').wrapAll("<div class='multigrid-right-wrapper'></div>");
  }
  if($('.banner-section').length > 0){
  $('#video-cover').click(function(){
   $('#video-popup-part').addClass('pop-open');
    $("body").addClass("show-video");
    $('.hover-video').trigger('pause');
  });
  
  $('.close_btn').click(function(){
    $('#video-popup-part').removeClass('pop-open');
    $("body").removeClass("show-video");
     $('.hover-video').trigger('play');
  });
  
    $('body').click(function(event){
    if(!$(event.target).closest('.close_btn').length && !$(event.target).closest('#video-cover').length) {
      $('#video-popup-part').removeClass('pop-open');
      $(this).removeClass("show-video");
      $('.hover-video').trigger('play');
    }
  });
} 

// retailer distributor form
  
$('.tab-retailer').click(function(){
  $(this).addClass('active');
  $('.tab-distributor').removeClass('active');
  $('#retailer-form').addClass('active').css('display', 'block');
  $('#distributor-form').removeClass('active').css('display', 'none');
});
  
$('.tab-distributor').click(function(){
  $(this).addClass('active');
  $('.tab-retailer').removeClass('active');
  $('#distributor-form').addClass('active').css('display', 'block');
  $('#retailer-form').removeClass('active').css('display', 'none');
});

$('.become-a-retailer-distributor .banner-btn1').click(function(){
    $('html, body').animate({
              scrollTop: $("#form-retailer").offset().top - 100
        }, 2500);
  $('.tab-retailer').addClass('active');
  $('.tab-distributor').removeClass('active');
  $('#retailer-form').addClass('active').css('display', 'block');
  $('#distributor-form').removeClass('active').css('display', 'none');
});  
  
$('.become-a-retailer-distributor .banner-btn2').click(function(){
      $('html, body').animate({
              scrollTop: $("#form-distributor").offset().top - 100
        }, 2500);
  $('.tab-distributor').addClass('active');
  $('.tab-retailer').removeClass('active');
  $('#distributor-form').addClass('active').css('display', 'block');
  $('#retailer-form').removeClass('active').css('display', 'none');
}); 
 
$('.become-a-retailer-distributor .btn-parts').click(function(){
     $('html, body').animate({
              scrollTop: $("#form-retailer").offset().top - 100
        }, 2500);
  $('.tab-retailer').addClass('active');
  $('.tab-distributor').removeClass('active');
  $('#retailer-form').addClass('active').css('display', 'block');
  $('#distributor-form').removeClass('active').css('display', 'none');
});

// Private Label Form
  $('.private-label-contract-manufacturing .button-started').click(function(){
     $('html, body').animate({
          scrollTop: $(".private-label-contract-manufacturing #form").offset().top - 100
    }, 2500);
  }); 
  
// contact Form
  $('.faq-scroll-btn').click(function(){
     $('html, body').animate({
          scrollTop: $("#FAQs").offset().top - 100
    }, 1000);
  });
  
//  Single blog page
if($('.single-blog-post-sec').length > 0){
  $('.related_product_slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows:true
  });
}

// Related Articles
if($('.related-part').length > 0){
  $('.related-article').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  infinite: true,
  speed: 300,
  responsive: [
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll:1
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});
}

// // For iframe Video Pause 
// let iframes = $('iframe');
// iframe.contentWindow.postMessage( '{"event":"command", "func":"pauseVideo", "args":""}', '*');

// Product Page ingredient Popup
if($('.main-product').length > 0){
  $('body').click(function(event){
    if(!$(event.target).closest('.popup-cross-icon').length && !$(event.target).closest('#view-ingredients').length && !$(event.target).closest('.inner-details').length && !$(event.target).closest('.popup-heading').length) { 
     $(".popup-wrapper").removeClass("active-popup");
      $(this).removeClass("show-nutrition");
    }
  });
  $(".popup-cross-icon").on("click", function () {
    $("body").removeClass("show-nutrition");
    $(".popup-wrapper").removeClass("active-popup");
  });
 
  $(document).on("click", ".view-ingredients", function (e) {
    e.preventDefault();
    $(".popup-wrapper").addClass("active-popup");
    $("body").addClass("show-nutrition");
    event.stopPropagation();
  });
  $(document).on("click", ".popup-description .metafield-rich_text_field a", function (){
    $("body").removeClass("show-nutrition");
    $(".popup-wrapper").removeClass("active-popup");
  });
}

$('.product-effects-list').wrapAll('<div class="pro-effects-wrapper"></div>');  
  // $('.product-effects-list .metafield-rich_text_field ul').addClass('divider-list');
  
  // --------------Ingredient slider--------------
if($('.pro-ingredients-slider').length > 0){
  $('.product-ingredients-slider').slick({
    infinite: false,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:2,
          slidesToScroll:2,
          infinite: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1
        }
      }
     
    ]
  });
}
  
});

// sticky add to cart

$(document).ready(function(){
   $(".sticky-bottom-price .quantity__button[name='plus']").click(function(){
       $( ".custom_dark_wrapper button.quantity__button.no-js-hidden[name='plus']" ).trigger( "click" );    
  });
  
   $(".sticky-bottom-price .quantity__button[name='minus']").click(function(){
       $( ".custom_dark_wrapper button.quantity__button.no-js-hidden[name='minus']" ).trigger( "click" );    
   });
  
     $(".sticky-bottom-price .variant-part").click(function(){
       $(".variant-wrap").trigger("click");    
   });

  // Quantity Click
   $(".quantity__button.no-js-hidden").click(function () {
    // data-id
     var data_id = $('.select-variation option:selected').attr('data-id');
     // console.log(data_id,'data_id');
     
     // Price Change
     var data_input = $('.stick_quantity_wrapper input#Quantity').val();
    if($('.custom_price').attr('data-price-only')){
      var textNormalPrice = $('.custom_price').attr('data-price-only');
       var total_price_update=((data_input*textNormalPrice).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
     }
     else{
      const sellingPlanId = $('input[name="selling_plan"]').val();
      const originalPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].onetimepurchaseprice;
      var split_PriceOriginal = originalPrice.split('$');
            
      if(sellingPlanId) {
        const discountPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].allocations.selling_plans.list['ID_'+sellingPlanId+''].pa_selling_plan_allocation_price;
          var split_PriceDiscount = discountPrice.split('$');
       
        var total_price_update=((data_input*split_PriceDiscount[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
      }
      else{
        var total_price_update=((data_input*split_PriceOriginal[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
       }
    }
  });

    $(".custom_cart_section .product-form_cart").click(function(){
       $( ".product-form__submit.button.button--full-width.button--secondary" ).trigger( "click" );    
    });
  // variant change
  $(".variant-part .select-variation").change(function(){
   setTimeout (function () {
     // Quantity check
     var quantity = $('.select-variation option:selected').attr('data-quantity');
     var Continue_selling = $('.select-variation option:selected').attr('data-continue-inven');
     // console.log(Continue_selling,'Continue_selling');
     if(quantity > 0){
       $('.custom_add-to-cart').removeAttr('disabled');
       $('.custom_add-to-cart span').text('Add to cart');
       $('.product-form__submit').removeAttr('disabled');
     }
     else if(quantity <= 0 && Continue_selling == 'true') {
       $('.custom_add-to-cart').removeAttr('disabled');
       $('.custom_add-to-cart span').text('Add to cart');
       $('.product-form__submit').removeAttr('disabled');
     }
     else if(quantity <= 0 && Continue_selling == 'false') {
        $('.custom_add-to-cart').attr('disabled','disabled');
        $('.custom_add-to-cart span').text('Sold out');
       $('.product-form__submit').attr('disabled','disabled');
     }
     // Image change
     var img = $('.select-variation option:selected').attr('data-image');
     // console.log(img,'img');
     $('.pro-img').attr('src',img);
     var get_url = window.location.href;
     var split_url= get_url.split('=');
     var split_new = split_url[1];
     
     var new_img = $('.slick-current .product__media.media.media--transparent:first').attr('media-id',split_new);
     var new_img_url = $('.slick-current .product__media.media.media--transparent:first').attr('media-id');
     if($(split_new == new_img_url)){
       $(".slick-current .product__media.media.media--transparent img:first").attr('src',img);
       $(".slick-current .product__media.media.media--transparent img:first").attr('srcset',img);
     }
    // data-id
     var data_id = $('.select-variation option:selected').attr('data-id');
     // console.log(data_id,'data_id');
     //   subscription price change    
    showDiscountPrice(data_id);
     
     // Price Change
    var data_input = $('.stick_quantity_wrapper input#Quantity').val();
    if($('.custom_price').attr('data-price-only')){
      var textNormalPrice = $('.custom_price').attr('data-price-only');
       var total_price_update=((data_input*textNormalPrice).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
     }
     else{
      const sellingPlanId = $('input[name="selling_plan"]').val();
      const originalPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].onetimepurchaseprice;
      var split_PriceOriginal = originalPrice.split('$');
            
      if(sellingPlanId) {
        const discountPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].allocations.selling_plans.list['ID_'+sellingPlanId+''].pa_selling_plan_allocation_price;
          var split_PriceDiscount = discountPrice.split('$');
       
        var total_price_update=((data_input*split_PriceDiscount[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
      }
      else{
        var total_price_update=((data_input*split_PriceOriginal[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
       }
    }
     
    },900);
  }); 

  // subscription-widget-price 
  function showDiscountPrice(data_id) {
   const sellingPlanId = $('input[name="selling_plan"]').val();
    const originalPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].onetimepurchaseprice;
    const comparePrice = SDSubscriptionConfig.variant['VID_'+data_id+''].compare_at_price;
  if(sellingPlanId) {
    const discountPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].allocations.selling_plans.list['ID_'+sellingPlanId+''].pa_selling_plan_allocation_price;
    const discountValue = SDSubscriptionConfig.selling_plans.list['ID_'+sellingPlanId+''].price_adjustment.position_1.value;
    const discountType = SDSubscriptionConfig.selling_plans.list['ID_'+sellingPlanId+''].price_adjustment.position_1.type;
    const discountSign = discountType == 'percentage' ? '%' : '';
    $('.price--show-badge').html(`<div class="selected_subscription_wrapper"><span class="selected_price">${discountPrice}</span><span class="cut_original_price">${originalPrice}</span><span class="sd_discount_ribbon discounttt10" style="background-color:#ffffff00; display: inline-block; color:#F94556;">Save ${discountValue} ${discountSign}</span></div>`);
  }else {
    $('.price--show-badge').html(`<div class="selected_subscription_wrapper"><span class="selected_price">${originalPrice}</span><span class="compare_price">${comparePrice}</span></div>`);
  }
    
}

 // add to cart Button Click
 $("button#cart_btn").click(function () {
   setTimeout (function () {
    var text_val = $('.stick_quantity_wrapper .quantity-data').attr("value");
     $('.stick_quantity_wrapper .quantity-data').val(text_val);
     
     // data-id
     var data_id = $('.select-variation option:selected').attr('data-id');
     // console.log(data_id,'data_id');
   
     
     // Price Change
    var data_input = $('.stick_quantity_wrapper input#Quantity').val();
    if($('.custom_price').attr('data-price-only')){
      var textNormalPrice = $('.custom_price').attr('data-price-only');
       var total_price_update=((data_input*textNormalPrice).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
     }
     else{
      const sellingPlanId = $('input[name="selling_plan"]').val();
      const originalPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].onetimepurchaseprice;
      var split_PriceOriginal = originalPrice.split('$');
            
      if(sellingPlanId) {
        const discountPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].allocations.selling_plans.list['ID_'+sellingPlanId+''].pa_selling_plan_allocation_price;
          var split_PriceDiscount = discountPrice.split('$');
       
        var total_price_update=((data_input*split_PriceDiscount[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
      }
      else{
        var total_price_update=((data_input*split_PriceOriginal[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
       }
    }
   },500);
 });

  //    sticky selling plan
    $('.sd-sellingGroupMain').on('change', function() {
      const slectedGroupId = $(this).val();
       // console.log('slectedGroupId', slectedGroupId);
      if(slectedGroupId == 'one-time') { 
        $('.sd-sellingplanselect').hide();
        $('input[name="selling_plan"]').val('');
        showDiscountPrice(ShopifyAnalytics.meta.selectedVariantId);
      }else {
         $('.sd-sellingplanselect').show();
        // $('.'+slectedGroupId).show();
        $('input[name="selling_plan"]').val($('.'+slectedGroupId).val());
        showDiscountPrice(ShopifyAnalytics.meta.selectedVariantId);
      }
       // data-id
       var data_id = $('.select-variation option:selected').attr('data-id');
       // console.log(data_id,'data_id');
       //   subscription price change    
      showDiscountPrice(data_id);
       
       // Price Change
      var data_input = $('.stick_quantity_wrapper input#Quantity').val();
      if($('.custom_price').attr('data-price-only')){
        var textNormalPrice = $('.custom_price').attr('data-price-only');
         var total_price_update=((data_input*textNormalPrice).toFixed(2));
          $('.productPriceContainer').text('$'+total_price_update);
       }
       else{
        const sellingPlanId = $('input[name="selling_plan"]').val();
        const originalPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].onetimepurchaseprice;
        var split_PriceOriginal = originalPrice.split('$');
              
        if(sellingPlanId) {
          const discountPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].allocations.selling_plans.list['ID_'+sellingPlanId+''].pa_selling_plan_allocation_price;
            var split_PriceDiscount = discountPrice.split('$');
         
          var total_price_update=((data_input*split_PriceDiscount[1]).toFixed(2));
          $('.productPriceContainer').text('$'+total_price_update);
        }
        else{
          var total_price_update=((data_input*split_PriceOriginal[1]).toFixed(2));
          $('.productPriceContainer').text('$'+total_price_update);
         }
      }
  });
  $('body .sd-sellingplanMain').on('change', function() {
      const slectedPlanId = $(this).val();
    // console.log('selling_plan_work', slectedPlanId);
      $('input[name="selling_plan"]').val(slectedPlanId);
    showDiscountPrice(ShopifyAnalytics.meta.selectedVariantId);
        // data-id
     var data_id = $('.select-variation option:selected').attr('data-id');
     // console.log(data_id,'data_id');
     //   subscription price change    
    showDiscountPrice(data_id);
     
     // Price Change
    var data_input = $('.stick_quantity_wrapper input#Quantity').val();
    if($('.custom_price').attr('data-price-only')){
      var textNormalPrice = $('.custom_price').attr('data-price-only');
       var total_price_update=((data_input*textNormalPrice).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
     }
     else{
      const sellingPlanId = $('input[name="selling_plan"]').val();
      const originalPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].onetimepurchaseprice;
      var split_PriceOriginal = originalPrice.split('$');
            
      if(sellingPlanId) {
        const discountPrice = SDSubscriptionConfig.variant['VID_'+data_id+''].allocations.selling_plans.list['ID_'+sellingPlanId+''].pa_selling_plan_allocation_price;
          var split_PriceDiscount = discountPrice.split('$');
       
        var total_price_update=((data_input*split_PriceDiscount[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
      }
      else{
        var total_price_update=((data_input*split_PriceOriginal[1]).toFixed(2));
        $('.productPriceContainer').text('$'+total_price_update);
       }
    }
  });

  //  sticky selling plan end

// add class to sticky add to cart when footer is in view 

  $(window).scroll(function() {
      $('.footer-block__newsletter').each(function() {
          var position = $(this).offset().top;
        // console.log(position);
          var scrollPosition = $(window).scrollTop();
        // console.log(scrollPosition);
          var windowHeight = $(window).height();
         // console.log(scrollPosition);
          if (position < scrollPosition + windowHeight) {
              $('.sticky-bottom-price').addClass('view_in-sticky');
          } else {
              $('.sticky-bottom-price').removeClass('view_in-sticky');
          }
      });
  });


// Shipping-return policy popup
  
  $('ul.policies.list-unstyled .shipping-returns').click(function(e) {
  e.preventDefault();
  // console.log("fsfsf");
    $('.modal.fade-return').addClass('model-open');
   $('body').addClass('return-open');
});
  
 $(document).on("click", ".modal.fade-return.model-open button.close", function(e) {
     e.preventDefault();
       $('.modal.fade-return').removeClass('model-open');
   $('body').removeClass('return-open');
});
  
  $('body').click(function(event){
  if(!$(event.target).closest('.modal.fade-return.model-open button.close').length && !$(event.target).closest('li>small.shipping-returns').length && !$(event.target).closest('.modal.fade-return .content-data-return').length){ 
   $('.modal.fade-return').removeClass('model-open');
    $(this).removeClass("return-open");
  }
});
  
// Mega menu header
  if($('.mega__link').hasClass('mega-menu__link--active')){
    $('#image-all').css('display','none');
  }
  else{
     $('#image-all').css('display','block');
  }
if ($(window).width() >= 890) {  
  $('.mega-menu-set').each(function() {
    $(this).hover(function() {
      $('.mega-menu-set').removeClass('active');
      $('.menu_image-wrap').css('display','none');
      $(this).addClass('active');
        var menu_attr = $(this).attr('data-menu');
        console.log('menu_attr', menu_attr);
        var img_attr = $(this).parents('.mega-menu__list').find('#image-'+menu_attr).attr('data-menu'); 
        console.log('img_attr', img_attr);
      $(this).parents('.mega-menu__list').find('#image-'+menu_attr).css('display','block');
    });
});
  
}
});


//  Blog page sort

  $('#sort-by').change(function() {
      var sortBy = $(this).val();
      var $activeTabPane = $('.blog-articles');
   if (sortBy === 'new-old') {
     // Do nothing, as it's already sorted by default
   } 
       else if (sortBy === 'old-new') {
          // Sort by data-date, old to new
          $activeTabPane.find('ul li').sort(function(a, b) {
              var dateA = $(a).data('date');
              var dateB = $(b).data('date');
              return new Date(dateA) - new Date(dateB);
          }).appendTo($activeTabPane.find('ul'));
      } else if (sortBy === 'a-z') {
          // Sort by data-title, A-Z
          $activeTabPane.find('ul li').sort(function(a, b) {
              var titleA = $(a).data('title').toUpperCase();
              var titleB = $(b).data('title').toUpperCase();
              return (titleA < titleB) ? -1 : (titleA > titleB) ? 1 : 0;
          }).appendTo($activeTabPane.find('ul'));
      } else if (sortBy === 'z-a') {
          // Sort by data-title, Z-A
          $activeTabPane.find('ul li').sort(function(a, b) {
              var titleA = $(a).data('title').toUpperCase();
              var titleB = $(b).data('title').toUpperCase();
              return (titleB < titleA) ? -1 : (titleB > titleA) ? 1 : 0;
          }).appendTo($activeTabPane.find('ul'));
      }
  });





$(document).ready(function() {
  
  // Private-label-page(cstm-radio)
   $("input.check-categories").click(function() {
            $(this).parent().toggleClass("active"); 
    });
     $("input.check-customize").click(function() {
            $(this).parent().toggleClass("active"); 
    });
});



